import { ConvertPriceTypePipe } from './pipes/convertPriceType.pipe';
import { ConvertOddTypePipe } from './pipes/convertOddType.pipe';
import { ConvertBetFTHTPipe } from './pipes/convertBetFTHT.pipe';
import { ConvertBetCSPipe } from './pipes/convertBetCS.pipe';
import { FilterLogPipe } from './pipes/filter-log.pipe';
import { DoughnutChartComponent } from './components/charts/original-chart/doughnut-chart/doughnut-chart.component';
import { PieLegendChartComponent } from './components/charts/customs-chart/pie-legend-chart/pie-legend-chart.component';
import { PieChartComponent } from './components/charts/original-chart/pie-chart/pie-chart.component';
import { NumberCounterComponent } from './components/number-counter/number-counter.component';
import { AdvancedPieChartComponent } from './components/charts/customs-chart/advanced-pie-chart/advanced-pie-chart.component';
import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AgentContentComponent,
  ContentComponent,
  IframePrintComponent,
  InputImgFileComponent,
  LineChartComponent,
  LoadingScreenComponent,
  MemberCreditFormComponent,
  ModalRightWhenMoblieComponent,
  PaginationComponent,
  ShowAutoSystemComponent,
  ShowDateTimeComponent,
  WinloseDetailComponent,
  WinloseDetailSlotComponent,
  WinloseDetailCasinoComponent,
  WinloseDetailSportsComponent,
  WinloseDetailEsportsComponent,
} from './components';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { AceEditorModule } from 'ng2-ace-editor';
import {
  CopyToClipboardDirective,
  LoadingDirective,
  NumberColorDirective,
  TooltipDirective,
  ViewImgDirective,
} from './directives';
import { PerfactScrollBarModule, PrimengModule } from './libs';
import { FromNowPipe } from './pipes/from-now.pipe';
import { ClipboardModule } from 'ngx-clipboard';
import { ImgHostPipe } from './pipes/img-host.pipe';
import {
  AdminSelectAgentFormComponent,
  AgentSelectAgentDownlineFromComponent,
  AgentSelectMemberFromComponent,
  InputFileFormComponent,
  SelectAccountBankFormComponent,
  SelectAgentFormComponent,
  SelectMemberFormComponent,
  SelectPromotionFormComponent,
} from './forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AgentChangePasswordOffcanvasComponent, AnnouncementFormCanvasComponent, BillFormOffcanvasComponent, BillStatusFormOffcanvasComponent, ChooseAgentOffcanvasComponent, CreditFormOffcanvasComponent, MemberTransactionOffcanvasComponent, ResetPasswordFormOffcanvasComponent } from './offcanvas';
import { BankImgPipe } from './pipes/bank-img.pipe';
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { BankLogoDirective } from './directives/bank-logo.directive';
import { ConvertOddTypeHTFTPipe } from './pipes/convertOddTypeHTFT.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SafePipePipe } from './pipes/safe-pipe.pipe';
import { NgxLottieViewModule } from 'ngx-lottie-view';

import {
  AlertModalComponent,
  BillModalComponent,
  ChangeStatusMemberModalComponent,
  ChooseLanguageModalComponent,
  GiveBonusFromDepositModalComponent,
  WithdrawChangeStatusModalComponent,
} from './modals';
import { ThaiBahtPipeModule } from 'ngx-thaibahtpipe';
import { TranslateModule } from '@ngx-translate/core';
import { SageContentComponent } from './components/sage-content/sage-content.component';
import { ChooseCurrencyModalComponent } from './modals/choose-currency-modal/choose-currency-modal.component';
import { ExAnyToThbPipe } from './pipes/ex-any-to-thb.pipe';
import { ExThbToAnyPipe } from './pipes/ex-thb-to-any.pipe';
import { RouterModule } from '@angular/router';
import { FilterSeamlessPipe } from './pipes/filter-seamless.pipe';
import { FocusInputToSelectDirective } from './directives/focus-input-to-select.directive';
import { AgentMapComponent } from './components/agent-map/agent-map.component';
import { ReportWinloseService } from '../apis/report-winlose.service';
import { SelectGameTypeComponent } from './forms/select-game-type/select-game-type.component';
import { PrintModalComponent } from './modals/print-modal/print-modal.component';
import { PrintInvoiceDetailComponent } from './components/print-invoice-detail/print-invoice-detail.component';
import { FormLottoComponent } from './components/form-agent/form-lotto/form-lotto.component';
import { FormSportsComponent } from './components/form-agent/form-sports/form-sports.component';
import { FormCasinoComponent } from './components/form-agent/form-casino/form-casino.component';
import { WinloseDetailLottoComponent } from './components/winlose-detail/winlose-detail-lotto/winlose-detail-lotto.component';
import { InputCurencyComponent } from './components/input-curency/input-curency.component';
import { ShowCurrencyComponent } from './components/show-currency/show-currency.component';
import { SidebarMenuByRolesComponent } from './components/sidebar-menu-by-roles/sidebar-menu-by-roles.component';
import { GameProviderImgComponent } from './components/game-provider-img/game-provider-img.component';
import { SelectGgCdnImageComponent } from './forms/select-gg-cdn-image/select-gg-cdn-image.component';
import { SelectGameComponent } from './forms/select-game/select-game.component';
import { FilterGameTypePipe } from './pipes/filter-game-type.pipe';
import { PrintInvoiceDetailEnComponent } from './components/print-invoice-detail-en/print-invoice-detail-en.component';
import { MinMaxPercentGameComponent } from './components/min-max-percent-game/min-max-percent-game.component';

const Modules = [
  FormsModule,
  ReactiveFormsModule,
  NgSelectModule,
  PrimengModule,
  PerfactScrollBarModule,
  ClipboardModule,
  NgxSkeletonLoaderModule,
  NgxCsvParserModule,
  VirtualScrollerModule,
  DragDropModule,
  ThaiBahtPipeModule,
  TranslateModule,
  NgxLottieViewModule,
];

const Components = [
  LoadingScreenComponent,
  ContentComponent,
  PaginationComponent,
  InputImgFileComponent,
  AgentContentComponent,
  ModalRightWhenMoblieComponent,
  IframePrintComponent,
  ChooseLanguageModalComponent,
  SageContentComponent,

  FormLottoComponent,
  FormCasinoComponent,
  FormSportsComponent,

  WinloseDetailComponent,
  WinloseDetailCasinoComponent,
  WinloseDetailLottoComponent,
  WinloseDetailSlotComponent,
  WinloseDetailSportsComponent,
  WinloseDetailEsportsComponent,

  SelectGameTypeComponent,
  SelectGameComponent,
  SelectAccountBankFormComponent,
  SelectMemberFormComponent,
  SelectAgentFormComponent,
  SelectPromotionFormComponent,
  InputFileFormComponent,
  ShowDateTimeComponent,
  ShowAutoSystemComponent,
  ShowCurrencyComponent,
  AdminSelectAgentFormComponent,
  AgentSelectAgentDownlineFromComponent,
  AgentSelectMemberFromComponent,

  GiveBonusFromDepositModalComponent,
  ChangeStatusMemberModalComponent,
  AlertModalComponent,
  WithdrawChangeStatusModalComponent,
  BillModalComponent,
  ChooseCurrencyModalComponent,
  PrintModalComponent,
  PrintInvoiceDetailComponent,
  PrintInvoiceDetailEnComponent,

  AgentChangePasswordOffcanvasComponent,
  AnnouncementFormCanvasComponent,
  MemberTransactionOffcanvasComponent,
  ResetPasswordFormOffcanvasComponent,
  BillFormOffcanvasComponent,
  BillStatusFormOffcanvasComponent,
  ChooseAgentOffcanvasComponent,
  CreditFormOffcanvasComponent,

  NumberCounterComponent,
  MemberCreditFormComponent,
  AgentMapComponent,

  DoughnutChartComponent,
  LineChartComponent,
  AdvancedPieChartComponent,
  PieChartComponent,
  PieLegendChartComponent,
  InputCurencyComponent,

  SidebarMenuByRolesComponent,
  GameProviderImgComponent,
  SelectGgCdnImageComponent,
  MinMaxPercentGameComponent,
];

const Directives = [
  BankLogoDirective,
  LoadingDirective,
  TooltipDirective,
  ViewImgDirective,
  FocusInputToSelectDirective,
  NumberColorDirective,
  CopyToClipboardDirective,
];

const Pipes = [
  FromNowPipe,
  ImgHostPipe,
  BankImgPipe,
  FilterLogPipe,
  SafePipePipe,
  ExAnyToThbPipe,
  ExThbToAnyPipe,
  // --------------
  ConvertBetCSPipe,
  ConvertBetFTHTPipe,
  ConvertOddTypePipe,
  ConvertOddTypeHTFTPipe,
  ConvertPriceTypePipe,
  FilterSeamlessPipe,
  FilterGameTypePipe,
];

@NgModule({
  declarations: [...Components, ...Directives, ...Pipes],
  imports: [CommonModule, RouterModule, ...Modules],
  exports: [...Modules, ...Components, ...Directives, ...Pipes],
  providers: [DecimalPipe, BankImgPipe],
})
export class SharedModule {}
